import classnames from "classnames";
import React, { Component } from "react";
import { Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap";

import Slider from "react-slick";

// Import client   Image
import Icon from "../../assets/images/testi-icon.png";

export default class CommercialSolution extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        {
          name: "Comprehensive Site Assessment",
          comment:
            "Our experts conduct a detailed analysis of your energy needs, site feasibility, and solar potential.",
        },
        {
          name: "Customized Solar Design",
          comment:
            "We create bespoke solar solutions optimized for your business operations, ensuring maximum efficiency and savings.",
        },
        {
          name: "Seamless Installation",
          comment:
            "Our professional team ensures hassle-free installation with minimal disruption to your business activities.",
        },
        {
          name: "Ongoing Support and Maintenance",
          comment:
            "Benefit from robust post-installation services, including system monitoring, cleaning, and maintenance.",
        },
        {
          name: "Commitment to Quality",
          comment:
            "We use only high-quality solar panels and components, backed by industry-leading warranties and performance guarantees.",
        },
      ],
      items2: [
        "Lower Operating Costs",
        "Enhanced Sustainability Profile",
        "Government Incentives and Benefits",
        "Energy Independence and Reliability",
        "Scalable and Customizable Solutions",
      ],
    };
  }

  render() {
    var settings = {
      dots: true,
      speed: 300,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      centerPadding: "20px",
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            infinite: true,
            centerPadding: "20px",
          },
        },
      ],
    };

    const slides = this.state.items.map((item, key) => {
      return (
        <div className="item" key={key}>
          <div className="testi-box text-center m-2">
            <div className="card border-0 shadow p-4 mb-4">
              <div className="mt-1 mb-3">
                <img
                  src={Icon}
                  alt={item.name}
                  className="testi-icon img-fluid d-block mx-auto w-auto"
                />
              </div>
              <p className="text-muted mb-0 f-15">{item.comment}</p>
            </div>
            <div className="test-user-info">
              <h5 className="f-17 mt-3 mb-1">{item.name}</h5>
            </div>
          </div>
        </div>
      );
    });

    const slides2 = this.state.items2.map((item, key) => {
      return (
        <NavItem key={key}>
          <NavLink
            href="#"
            className={classnames(
              {
                active: true,
              },
              "rounded p-2"
            )}
          >
            <p className="text-muted f-15 mb-0">{item}</p>
          </NavLink>
        </NavItem>
      );
    });

    return (
      <React.Fragment>
        <section className="section" id="commercial-solution">
          <Container>
            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="text-center mb-5">
                  <h2 className="service-title f-24">COMMERCIAL SOLUTION</h2>
                  <h3
                    className="hero-1-title fw-normal"
                    style={{ color: "#2077b8" }}
                  >
                    Commercial Solar Solutions
                  </h3>
                  <p className="text-muted">
                    As businesses in India face rising energy costs and
                    increasing pressure to adopt sustainable practices, Solar
                    Storm offers the perfect solution: cutting-edge commercial
                    solar installations designed to power your operations while
                    reducing your environmental impact. Join the wave of
                    forward-thinking companies leading India’s clean energy
                    transition.
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center">
              <Col lg={6} md={10}>
                <div className="mb-5 mb-lg-0">
                  <div className="text-center">
                    {/* <img
                      src={"/assets/commercial-solutions.jpg"}
                      alt=""
                      className="img-fluid d-block w-75 mx-auto"
                      style={{ maxHeight: "360px" }}
                    /> */}
                    <img
                      src={"/assets/commercial-solutions.jpg"}
                      alt="COMMERCIAL SOLUTION"
                      className="img-fluid d-block mx-auto"
                      style={{ maxHeight: "360px" }}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={5} className="offset-lg-1">
                <h4 className="line-height-1_4 mb-2">
                  Why Choose Solar for Your Business?
                </h4>
                <div className="features-content">
                  <Nav
                    className="flex-column"
                    pills
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                    style={{ gap: 4 }}
                  >
                    {slides2}
                  </Nav>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <h4 className="line-height-1_4 mt-5 mb-2">
                  How Solar Storm Helps Your Business Shine
                </h4>
                <div
                  id="testi-clients"
                  className="owl-carousel owl-theme testi-content"
                >
                  <Slider {...settings}>{slides}</Slider>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
